import {
    readCookie, createCookie
} from '../Utils.js';

export default class UTMController {
    static setCookie(value) {
        const jsDate = new Date();
        const sessionExpiryDate = jsDate.setFullYear(jsDate.getFullYear() - 10);
        createCookie("sos_utm", JSON.stringify(value), sessionExpiryDate);        
    }
    
    static getReferrer() {
        try {
            return new URL(document.referrer);
        }
        catch {}    // eslint-disable-line no-empty    
        
        return null;
    }
    
    static getSearchEngine() {
        const url = UTMController.getReferrer();
        if (url == null)
            return "";
        // https://iservice.sos-kd.org/browse/DIGSP-6155?focusedId=488897&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-488897
        if (url.host.includes("google."))
            return "google";
        if (url.host.includes("bing."))
            return "bing";
        if (url.host.includes("yahoo."))
            return "yahoo";
        if (url.host.includes("ecosia."))
            return "ecosia";
        if (url.host.includes("duckduckgo."))
            return "duckduckgo";
        return "";        
    }
    static getValue() {
        const url = new URL(window.location.href);
        const parameters = [
            "utm_campaign",
            "utm_source",
            "utm_media",
            "utm_term",
            "utm_content",
            "utm_medium"];
        let values = {};
        
        for (const [key, value] of url.searchParams) {
            if (parameters.includes(key))
                values[key] = value;
        }
        
        const se = UTMController.getSearchEngine();
        if (document.referrer == "") {
            if (!("utm_source" in values))
                values["utm_source"] = "direct";
            if (!("utm_medium" in values))
                values["utm_medium"] = "direct";
        }
        else if (se != "") {
            if (!("utm_source" in values))
                values["utm_source"] = se;
            if (!("utm_medium" in values))
                values["utm_medium"] = "organic";
        }
        else {
            if (!("utm_source" in values)) {
                const ref = UTMController.getReferrer();
                if (ref != null)
                    values["utm_source"] = ref.host;
            }
            if (!("utm_medium" in values))
                values["utm_medium"] = "referral";
        }
        return values;
    }
    static init() {
        if (readCookie("sos_utm") != null)
            return;
        const value = UTMController.getValue();
        if (Object.keys(value).length !== 0)
            UTMController.setCookie(value);
    }
}